import { createLucideIcon } from 'lucide-react';
export const Logo = createLucideIcon('logo', [
  [
    'path',
    {
      d: 'M0.8105 25.3013C0.9748 24.5969 1.0687 23.5032 1.0924 22.0204H1.9425C1.9127 23.5466 1.8218 24.6563 1.6698 25.3501L0.8105 25.3021V25.3013Z',
      key: '8ot1db',
    },
  ],
  [
    'path',
    {
      d: 'M10.0456 1.9003L10.1739 2.1569C10.2037 2.2171 10.2656 2.2552 10.3328 2.2552H13.7179C13.7851 2.2552 13.8469 2.2171 13.8767 2.1569L14.0051 1.9003H10.0456Z',
      key: 'y9dsrb',
    },
  ],
  [
    'path',
    {
      d: 'M10.0703 14.8304C10.0703 14.5372 10.3086 14.2988 10.6034 14.2988H13.4455C13.7395 14.2988 13.9786 14.5364 13.9786 14.8304C13.9786 15.1244 13.7403 15.362 13.4455 15.362H10.6034C10.3094 15.362 10.0703 15.1244 10.0703 14.8304Z',
      key: '5bag0k',
    },
  ],
  [
    'path',
    {
      d: 'M10.1228 22.6838C10.4451 22.7592 10.6964 22.9344 10.8767 23.2101C11.0569 23.4858 11.147 23.8498 11.147 24.3022V25.8604H10.3237V24.322C10.3535 24.0303 10.316 23.8033 10.2122 23.6411C10.1075 23.4789 9.97081 23.3845 9.80048 23.3578L7.89408 26.0165L7.17383 25.6228L9.00004 23.0928C9.2116 22.8255 9.36513 22.4904 9.45907 22.089C9.55302 21.6877 9.58509 21.3457 9.55531 21.0647H7.32658V20.2734H10.4634V20.952C10.4665 21.6131 10.3527 22.1903 10.1236 22.6831L10.1228 22.6838Z',
      key: '1klzn2',
    },
  ],
  [
    'path',
    {
      d: 'M14.0527 20.2891H17.6372V25.8592H14.0527V20.2891Z',
      key: '10u7bl',
    },
  ],
  [
    'path',
    {
      d: 'M14.334 12.3504C14.334 10.6878 15.6859 9.3398 17.3532 9.3398C19.0206 9.3398 20.3725 10.6878 20.3725 12.3504C20.3725 14.0129 19.0206 15.3609 17.3532 15.3609C15.6859 15.3609 14.334 14.0129 14.334 12.3504Z',
      key: '1hlji4',
    },
  ],
  [
    'path',
    {
      d: 'M14.9028 21.0963V25.052H16.7825V21.0963H14.9028Z',
      key: '2vjcj6',
    },
  ],
  [
    'path',
    {
      d: 'M17.3532 10.4022C16.274 10.4022 15.3995 11.2742 15.3995 12.3504C15.3995 13.4265 16.274 14.2985 17.3532 14.2985C18.4325 14.2985 19.307 13.4265 19.307 12.3504C19.307 11.2742 18.4325 10.4022 17.3532 10.4022Z',
      key: 'q9aatt',
    },
  ],
  [
    'path',
    {
      d: 'M18.7821 14.0714C19.0059 13.8802 19.342 13.9061 19.5337 14.1292L21.6654 16.6089C21.8571 16.8321 21.8312 17.1672 21.6074 17.3583C21.3836 17.5495 21.0475 17.5236 20.8558 17.3005L18.7241 14.8208C18.5324 14.5976 18.5583 14.2625 18.7821 14.0714Z',
      key: 'gad53q',
    },
  ],
  [
    'path',
    {
      d: 'M23.3473 21.0714H21.9374C21.6808 21.9762 21.3317 22.7408 20.8902 23.3646L20.1387 22.9708C20.4549 22.5184 20.7283 21.9602 20.9597 21.2961C21.1912 20.632 21.3691 19.9268 21.4944 19.1797L22.3491 19.2962L22.139 20.2802H24.2471V22.2039C24.2562 22.555 24.0989 22.9914 23.775 23.5153C23.4512 24.0385 22.6767 24.9121 21.4501 26.1359L20.7925 25.6219C21.9771 24.433 22.7019 23.6402 22.9677 23.2419C23.2335 22.8444 23.3603 22.4796 23.3481 22.1476V21.0714H23.3473Z',
      key: 'rzk8yk',
    },
  ],
  [
    'path',
    {
      d: 'M24.8245 19.2886H25.2453V20.3731H24.8245V19.2886Z',
      key: '1fyi9k',
    },
  ],
  [
    'path',
    {
      d: 'M25.6883 19.2886H26.1092V20.3731H25.6883V19.2886Z',
      key: '1glmws',
    },
  ],
  [
    'path',
    {
      d: 'M3.2004 21.0807V25.8679H2.3587V21.0807H0.8556V20.2894H2.3595V19.2734H3.2012V20.2894H4.66V21.0807H3.2012H3.2004Z',
      key: '14jlmy',
    },
  ],
  [
    'path',
    {
      d: 'M3.9169 23.1453C3.926 22.9739 3.8886 22.8239 3.8054 22.6952C3.7221 22.5665 3.6052 22.4477 3.4563 22.338L4.1277 21.8719C4.2827 21.9923 4.4332 22.156 4.5798 22.3616C4.7257 22.568 4.7945 22.8087 4.786 23.0844V25.2929H3.9176V23.1445L3.9169 23.1453Z',
      key: 'xh3ng1',
    },
  ],
  [
    'path',
    {
      d: 'M6.51834 2.786C6.51834 1.7099 7.39287 0.837891 8.4721 0.837891H15.5768C16.6561 0.837891 17.5306 1.7099 17.5306 2.786V8.09953C17.5306 8.39273 17.2923 8.63111 16.9975 8.63111C16.7026 8.63111 16.4643 8.39349 16.4643 8.09953V2.786C16.4643 2.29707 16.0664 1.90029 15.5761 1.90029H8.47134C7.98099 1.90029 7.58306 2.29707 7.58306 2.786V15.5378C7.58306 16.0268 7.98099 16.4236 8.47134 16.4236H14.1554C14.4495 16.4236 14.6885 16.6612 14.6885 16.9551C14.6885 17.2491 14.4502 17.4867 14.1554 17.4867H8.47134C7.39211 17.4867 6.51758 16.6147 6.51758 15.5386V2.786H6.51834Z',
      key: '11hedc',
    },
  ],
  [
    'path',
    {
      d: 'M8.7304 1.09C8.8274 0.9331 8.9992 0.8379 9.1833 0.8379H14.8674C15.0522 0.8379 15.2233 0.9331 15.3203 1.09C15.4173 1.2469 15.4265 1.4426 15.344 1.6071L14.8299 2.6322C14.6191 3.0526 14.1891 3.3176 13.7179 3.3176H10.3328C9.8615 3.3176 9.4315 3.0526 9.2207 2.6322L8.7067 1.6071C8.6242 1.4426 8.6326 1.2469 8.7304 1.09Z',
      key: '13ycp7',
    },
  ],
]);
